import {createCoreSagas} from '../../../redux/factories/crud/createSagas';
import {normalizeResponse} from '../../../redux/factories/helper';
import {actions, actionTypes} from './group.reducers';
import {apiClient} from '../../../shared/api';
import {call, put} from 'redux-saga/effects';
import {notifyError, notifySuccess} from "../../../shared/notificationUtils";

import createStore from "../../../redux/factories/crud/crudFactory";
import {LIST_GROUP_OPTIONS, LIST_GROUP_OPTIONS_FAILED, LIST_GROUP_OPTIONS_SUCCESS} from "./constants";
import {solveDownloadResponse} from "../../ui/components/AppMenu/redux/utils";

export const groupStore = createStore('api/v2/groups');

// download groups
function* downloadGroups({payload}) {
    let response = yield call(apiClient.post, 'report-service/api/v2/report/export-groups', payload);
    if (response.error) {
        yield put(actions['downloadGroupsFailed'](response.detail));
        yield call(notifyError, response.detail);
    } else {
        solveDownloadResponse(response);
        yield call(notifySuccess, 'Successfully download groups list');
        yield put(actions['downloadGroupsSuccess'](response));
    }
}

// list users in corporate
function* updateUserInGroup({payload}) {
    const {group_id, removing_ids, adding_ids} = payload;

    let response = yield call(apiClient.post, `api/v2/groups/${group_id}/modify-users-list`, {
        removing_ids, adding_ids
    });

    if (response.error) {
        yield put(actions['updateUserInGroupFailed'](response.detail));
        yield call(notifyError, response.detail);
    } else {
        response = response.data;
        yield put(actions['updateUserInGroupSuccess'](response));
        yield put(groupStore.actions.list());
    }
}

// list permission of a group
function* listGroupPermission(group_id) {
    if (!group_id.payload) {
        yield put(actions['listGroupPermissionSuccess']([]));
        return
    }
    let response = yield call(apiClient.get, `api/v2/groups/permissions`, group_id.payload);
    if (response.error) {
        yield put(actions['listGroupPermissionFailed'](response.detail));
        yield call(notifyError, response.detail);
    } else {
        response = response.data;
        yield put(actions['listGroupPermissionSuccess'](response));
        yield put(groupStore.actions.list());
    }
}

// list group options
function* listGroupOption({payload}) {
    let params = {};

    if (payload) {
        const {corporate_id} = payload;
        params = {corporate_id}
    }
    let response = yield call(apiClient.list, 'api/v2/groups/options', undefined, undefined, undefined, params);

    if (response.error) {

        yield put(actions[LIST_GROUP_OPTIONS_FAILED](response.detail));
        yield call(notifyError, response.detail);

    } else {
        response = response.data;
        response.forEach(normalizeResponse);
        yield put(actions[LIST_GROUP_OPTIONS_SUCCESS](response));
    }
}

export const groupCoreSaga = createCoreSagas([
    {
        type: actionTypes['listGroupPermission'],
        callback: listGroupPermission,
    },
    {
        type: actionTypes['updateUserInGroup'],
        callback: updateUserInGroup,
    },
    {
        type: actionTypes[LIST_GROUP_OPTIONS],
        callback: listGroupOption,
    },

    {
        type: actionTypes['downloadGroups'],
        callback: downloadGroups,
    },
]);
